<template>
    <div>
        <div class="quoted-messages" v-if="assocWhatsappInfoId !== '1'">
            <div class="quoted-messages-left"></div>
            <div class="quoted-messages-content">
                <div class="quoted-name">{{ newAssocWhatsAppRecordUserVO.nickname }}{{ newAssocWhatsAppRecordUserVO.nickname ? '：' : '' }}</div>
                <!-- 引用图片 -->
                <div class="imgcontent" v-if="newAssocContent.msgType == 'image' || newAssocContent.msgType == 'sticker'">
                    <img :src="newAssocContent.urls" class="img-box" />
                    <div> {{ newAssocContent.caption }}</div>
                </div>
                <!-- 引用视频 -->
                <div class="video_box" v-else-if="newAssocContent.msgType == 'video'">
                    <video ref="videoPlayer" controls :src="newAssocContent.urls" class="video_content"></video>
                </div>
                <!-- 引用文件 -->
                <div class="video_box" v-else-if="newAssocContent.msgType == 'document'">
                    <el-row class="file_style">
                        <el-col :span="20" class="file_sub">
                            <div>{{ newAssocContent.fileName | fileNameFilter }}</div>
                            <div class="fileSize">{{ newAssocContent.fileSizeStr }}</div>
                        </el-col>
                        <el-col :span="4">
                            <img :src="newAssocContent.fileName | numfilters" class="fileName" />
                        </el-col>
                    </el-row>
                </div>
                <div v-else-if="newAssocContent.msgType == 'audio'">
                    <audio-play :url="newAssocContent.urls" :position="'left'"></audio-play>
                </div>
                <!-- 文字 -->
                <div class="content" v-else-if="newAssocContent.msgType == 'text' || newAssocContent.msgType == 'button'">
                    <div v-html="newAssocContent.content.replace(/\n/g, '<br />')"></div>
                </div>
                <!-- 位置 -->
                <div v-else-if="newAssocContent.msgType == 'location'">
                    <div class="content" v-if="newAssocContent.locationVO">
                        <div style="font-size: 16px;"
                            v-if="!newAssocContent.locationVO.address && !newAssocContent.locationVO.name">定位消息
                        </div>
                        <div style="font-size: 16px;" v-else>定位消息：{{ newAssocContent.locationVO.name }}<span
                                v-if="newAssocContent.locationVO.name">，</span>{{
                                    newAssocContent.locationVO.address }}</div>
                    </div>
                    <div class="content" v-else>未知定位信息</div>
                </div>
                <!-- 模板 -->
                <div v-else-if="newAssocContent.msgType == 'template'">
                    <whatsappTemplateMsg v-model="newAssocContent.templateContentVO"></whatsappTemplateMsg>
                </div>
                <!-- 联系人消息 -->
                <div v-else-if="newAssocContent.msgType == 'contacts'">
                    <div class="content" style="padding: 0">
                        <div class="contact-info" @click="viewContact(newAssocContent.contactVOList)">
                        {{ newAssocContent.contactVOList[0].name.formattedName }}<span v-if="newAssocContent.contactVOList.length > 1">等另外</span>{{ newAssocContent.contactVOList.length == 1 ? '' : newAssocContent.contactVOList.length - 1 + '个联系人'}} 
                        </div>
                    </div>
                </div>
                <!-- 未知消息 -->
                <div class="content" v-else>暂不支持此类消息</div>
            </div>
        </div>
        <div class="quoted-messages-content zhuanfa-content" v-if="assocWhatsappInfoId === '1'">
            <img src="@/assets/chat/zhuanfa.png" alt="">
            <div>转发</div>
        </div>
        <el-dialog title="联系人信息" :visible.sync="contactVisible" width="500px">
            <div class="contact-dialog" v-for="(item, index) in contactInfoList" :key="index">
                <div class="contact-info-left">
                <img :src="require('@/assets/default.png')" class="img" />
                </div>
                <div class="contact-info-right">
                <div class="contact-info-name">{{ item.name.formattedName }} 
                    <div class="contact-info-phone">
                    <div v-for="i in item.phones" :key="i.id">{{ i.phone }}</div>
                    </div>
                </div>
                <div v-if="item.org">公司：{{ item.org.company }}</div>
                <div v-if="item.address">地址： {{ item.address.country + item.address.city }} </div>
                <div v-if="item.emails">邮箱：{{ item.emails }}</div>
                <div style="display: flex" v-if="item.urls">网址：
                    <div>
                    <div v-for="ii in item.urls" :key="ii.id">{{ ii.url }}</div>
                    </div>
                </div> 
                <div v-if="item.birthday">生日：{{ item.birthday }}</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import audioPlay from '@/components/chat/components/audio-play.vue';
import whatsappTemplateMsg from './whatsapp-template-msg.vue';
export default {
    props: {
        assocContent: {
            type: Object,
            default: () => { }
        },
        assocWhatsAppRecordUserVO: {
            type: Object,
            default: () => { }
        },
        assocWhatsappInfoId: {}
    },
    data() {
        return {
            newAssocContent: {},
            newAssocWhatsAppRecordUserVO: {},
            contactVisible: false,
            contactInfoList:[]
        }
    },
    watch: {
        assocContent: {
            handler(val) {
                this.newAssocContent = val
            },
            deep: true,
            immediate: true
        },
        assocWhatsAppRecordUserVO: {
            handler(val) {
                if(val) {
                    this.newAssocWhatsAppRecordUserVO = val
                }
                
            },
            deep: true,
            immediate: true
        }
    },
    filters: {
        fileNameFilter(value) {
            let len = value.length;
            if (!value) return '';
            if (value.length > 20) {
                return value.substring(0, 12) + '...' + value.substring(len - 12, len);
            }
            return value;
        },
        numfilters(val) {
            const typeList = {
                xls: {
                    img: 'xls.png',
                },
                xlsx: {
                    img: 'xls.png',
                },
                txt: {
                    img: 'txt.png',
                },
                pdf: {
                    img: 'pdf.png',
                },
                doc: {
                    img: 'word.png',
                },
                docx: {
                    img: 'word.png',
                },
                zip: {
                    img: 'zip.png',
                },
                ppt: {
                    img: 'ppt.png',
                },
                pptx: {
                    img: 'ppt.png',
                },
                rar: {
                    img: 'rar.png',
                },
                others: {
                    img: 'o-file.png',
                },
                // mp4: {
                // 	img: 'file.png',
                // },
            };
            const type = val.substring(val.lastIndexOf('.') + 1).toLowerCase(); // 截取的图片类型
            return type && typeList[type]
                ? require(`@/assets/${typeList[type].img}`)
                : require(`@/assets/${typeList['others'].img}`);
        },
    },
    components: {
        audioPlay,
        whatsappTemplateMsg
    },
    methods: {
        viewContact(list) {
            this.contactInfoList = list
            this.contactVisible = true
        }
    }
}
</script>
<style lang="scss" scoped>
.zhuanfa-content {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img {
        width: 20px;
        margin-right: 5px;
    }
}
.quoted-messages {
    background-color: rgba(0, 0, 0, 0.03);
    margin-bottom: 10px;
    display: flex;
    border-radius: 6px;

    .quoted-messages-left {
        min-width: 5px;
        max-width: 5px;
        background-color: rgba(185, 187, 189, .6);
        border-radius: 6px 0 0 6px;
    }

    .quoted-name {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .quoted-messages-content {
        padding: 10px;
        margin-left: 5px;
    }
}

.imgcontent {
    .img-box {
        cursor: pointer;
        max-width: 200px;
        max-height: 150px;
        object-fit: contain;
    }
}

.video_box {
    display: flex;

    .video_content {
        width: 200px;
        // height: 180px;
        // object-fit: fill;
        border-radius: 10px;
    }
}

.file_style {
    cursor: pointer;
    width: 260px;
    max-height: 100px;
    // height: 80px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
    padding: 15px;

    .file_sub {
        word-wrap: break-word;
        display: block;

        .fileSize {
            margin-top: 10px;
        }
    }

    .fileName {
        width: 35px;
        height: 40px;
    }
}
.contact-dialog {
  display: flex;
  margin-bottom: 20px;
  div {
    line-height: 30px;
  }
  .contact-info-right {
    margin-left: 20px;
  }
  .contact-info-name {
    display: flex;
  }
  .contact-info-phone {
    margin-left: 20px;
  }
}
.contact-info {
  cursor: pointer;
}
.view-all {
  text-align: center;
  border-top: 1px solid rgba(185, 187, 189, 0.4);
  padding: 11px 15px;
  cursor: pointer;
}
.img {
	width: 40px;
	height: 40px;
	background: #d3d6db;
	border-radius: 20px;
	object-fit: contain;
	display: inline-block;
	vertical-align: top;
}
</style>